module.exports = __webpack_public_path__ + "img/video_thumb_vatandas.8a5746b2.png";